/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_A1Inputs */

const en_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes! Alchema is free to start with 5 AI actions per month. No credit card required.`)
};

const de_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja! Alchema ist kostenlos mit 5 KI-Aktionen pro Monat. Keine Kreditkarte erforderlich.`)
};

const fr_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui ! Alchema est gratuit pour commencer avec 5 actions IA par mois. Aucune carte de crédit requise.`)
};

const es_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Sí! Alchema es gratuito para empezar con 5 acciones de IA por mes. No se requiere tarjeta de crédito.`)
};

const it_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì! Alchema è gratuito per iniziare con 5 azioni AI al mese. Non è richiesta la carta di credito.`)
};

const nl_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja! Alchema is gratis te starten met 5 AI-acties per maand. Geen creditcard vereist.`)
};

const pl_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak! Alchema jest bezpłatne do rozpoczęcia z 5 akcjami AI miesięcznie. Karta kredytowa nie jest wymagana.`)
};

const fi_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kyllä! Alchema on ilmainen aloittaa 5 tekoälytoiminnolla kuukaudessa. Luottokorttia ei tarvita.`)
};

const da_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja! Alchema er gratis at starte med 5 AI-handlinger om måneden. Intet kreditkort kræves.`)
};

const sv_pricing_faq_a1 = /** @type {(inputs: Pricing_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja! Alchema är gratis att komma igång med 5 AI-åtgärder per månad. Inget kreditkort krävs.`)
};

/**
* | output |
* | --- |
* | "Yes! Alchema is free to start with 5 AI actions per month. No credit card required." |
*
* @param {Pricing_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_a1 = /** @type {((inputs?: Pricing_Faq_A1Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_A1Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_a1(inputs)
	if (locale === "fr") return fr_pricing_faq_a1(inputs)
	if (locale === "es") return es_pricing_faq_a1(inputs)
	if (locale === "it") return it_pricing_faq_a1(inputs)
	if (locale === "nl") return nl_pricing_faq_a1(inputs)
	if (locale === "pl") return pl_pricing_faq_a1(inputs)
	if (locale === "fi") return fi_pricing_faq_a1(inputs)
	if (locale === "da") return da_pricing_faq_a1(inputs)
	if (locale === "sv") return sv_pricing_faq_a1(inputs)
	return en_pricing_faq_a1(inputs)
});